import Vue from 'vue';
import ObserverManager from '@app/global/ViewportObserver';
Vue.directive('observe', {
    bind: function (el, binding) {
        if (!binding.value || typeof binding.value === 'string') {
            el.classList.add(binding.value || 'observe' + '-before-enter');
            el.addEventListener('transitionend', function () {
                el.classList.remove(binding.value || 'observe' + '-before-enter');
                el.classList.remove('observe-enter');
                el.classList.remove('enter');
            });
        }
    },
    inserted: function (el, binding) {
        Vue.nextTick(function () {
            ObserverManager.add(el, function () {
                if (typeof binding.value === 'function') {
                    binding.value();
                }
                el.classList.add('enter');
            });
        });
    }
});
